import React, { useState, useEffect } from "react";
import { db } from "../../firebase/config";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import { useTheme } from "../../context/ThemeContext";
import Header from "../../components/Header";

export default function AnaliticaClientes() {
  const { theme } = useTheme();
  const [metricas, setMetricas] = useState([]);
  const [clinicaSel, setClinicaSel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [actualizando, setActualizando] = useState(false);
  const [ultimaActualizacion, setUltimaActualizacion] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'metricas_consolidadas'), snap => {
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setMetricas(data);
      if (data.length > 0) {
        const fechas = data.map(m => m.actualizadoEn?.toDate ? m.actualizadoEn.toDate() : new Date(0));
        setUltimaActualizacion(new Date(Math.max(...fechas)));
      }
      setLoading(false);
    });
    return unsub;
  }, []);

  async function actualizarMetricas() {
    setActualizando(true);
    try {
      const res = await fetch('https://consolidarmetricas-cofaaygy6q-uc.a.run.app', { method: 'POST' });
      const data = await res.json();
      if (data.ok) alert(`Métricas actualizadas para ${data.clinicas} clínicas`);
    } catch (e) { alert('Error al actualizar: ' + e.message); }
    setActualizando(false);
  }

  const btnPrimaryStyle = { background: `linear-gradient(135deg, ${theme.accent}, ${theme.accentDark})`, border: 'none', borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: '#FFFFFF', fontWeight: '600', fontFamily: "'Montserrat', sans-serif" };
  const btnSecondaryStyle = { background: 'transparent', border: `0.5px solid ${theme.borderInput}`, borderRadius: '8px', padding: '8px 16px', fontSize: '13px', cursor: 'pointer', color: theme.secondary, fontFamily: "'Montserrat', sans-serif" };
  const seccion = { fontSize: '11px', fontWeight: '700', color: theme.secondary, letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '12px' };
  const card = (label, valor, color, bg) => (
    <div key={label} style={{ background: bg || theme.bgCard, padding: '12px 14px', borderRadius: '10px', border: `0.5px solid ${theme.border}` }}>
      <div style={{ fontSize: '11px', color: color || theme.secondary, marginBottom: '4px', fontWeight: '500' }}>{label}</div>
      <div style={{ fontSize: '20px', fontWeight: '700', color: color || theme.primary }}>{valor ?? '—'}</div>
    </div>
  );

  const clinicaSelData = metricas.find(m => m.id === clinicaSel);

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, fontFamily: "'Montserrat', sans-serif" }}>
      <Header titulo="Analítica de clientes" backLabel="Super Admin" backRuta="/dashboard" />
      <div style={{ padding: '24px', background: theme.bg, display: 'flex', flexDirection: 'column', gap: '20px' }}>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px' }}>
          <div style={{ fontSize: '13px', color: theme.secondary }}>
            {ultimaActualizacion ? `Última actualización: ${ultimaActualizacion.toLocaleString('es-AR')}` : 'Sin datos aún'}
          </div>
          <button onClick={actualizarMetricas} disabled={actualizando} style={btnPrimaryStyle}>
            {actualizando ? 'Actualizando...' : '↻ Actualizar métricas'}
          </button>
        </div>

        {loading
          ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px' }}>Cargando...</div>
          : metricas.length === 0
            ? <div style={{ textAlign: 'center', color: theme.secondary, padding: '48px', fontSize: '13px' }}>No hay métricas aún. Hacé clic en "Actualizar métricas".</div>
            : <>
                <div>
                  <div style={seccion}>Resumen global — {metricas.length} clínicas</div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '10px' }}>
                    {card('Total turnos', metricas.reduce((a, m) => a + (m.turnos?.total || 0), 0), theme.accent, theme.infoBg)}
                    {card('Total pacientes', metricas.reduce((a, m) => a + (m.pacientes?.total || 0), 0), theme.success, theme.successBg)}
                    {card('Total usuarios', metricas.reduce((a, m) => a + (m.usuarios?.total || 0), 0), theme.secondary, theme.bgCard)}
                    {card('Ingresos ARS', '$' + metricas.reduce((a, m) => a + (m.caja?.totalIngresosARS || 0), 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.success, theme.successBg)}
                    {card('Ingresos USD', 'USD ' + metricas.reduce((a, m) => a + (m.caja?.totalIngresosUSD || 0), 0).toFixed(0), theme.accent, theme.infoBg)}
                    {card('Financiaciones clientes', metricas.reduce((a, m) => a + (m.financiaciones?.clientes?.total || 0), 0), theme.warning, theme.warningBg)}
                  </div>
                </div>

                <div>
                  <div style={seccion}>Seleccioná una clínica para ver el detalle</div>
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '20px' }}>
                    {metricas.map(m => (
                      <button key={m.id} onClick={() => setClinicaSel(clinicaSel === m.id ? null : m.id)} style={{ padding: '8px 16px', fontSize: '13px', borderRadius: '8px', cursor: 'pointer', border: clinicaSel === m.id ? 'none' : `0.5px solid ${theme.borderInput}`, background: clinicaSel === m.id ? theme.accent : 'transparent', color: clinicaSel === m.id ? '#FFFFFF' : theme.secondary, fontFamily: "'Montserrat', sans-serif", fontWeight: clinicaSel === m.id ? '600' : '400' }}>
                        {m.clinicaNombre || m.id}
                      </button>
                    ))}
                  </div>

                  {clinicaSelData && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>

                      <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                        <div style={seccion}>Turnos</div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '10px', marginBottom: '16px' }}>
                          {card('Total', clinicaSelData.turnos?.total, theme.accent, theme.infoBg)}
                          {card('Atendidos', clinicaSelData.turnos?.atendidos, theme.success, theme.successBg)}
                          {card('Cancelados', clinicaSelData.turnos?.cancelados, theme.error, theme.errorBg)}
                          {card('Ausentes', clinicaSelData.turnos?.ausentes, theme.warning, theme.warningBg)}
                          {card('Tasa atención', clinicaSelData.turnos?.total > 0 ? Math.round((clinicaSelData.turnos.atendidos / clinicaSelData.turnos.total) * 100) + '%' : '—', theme.accent, theme.infoBg)}
                        </div>
                        {clinicaSelData.turnos?.porTipo && (
                          <div>
                            <div style={{ fontSize: '11px', color: theme.secondary, marginBottom: '8px', fontWeight: '500' }}>POR TIPO</div>
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                              {Object.entries(clinicaSelData.turnos.porTipo).map(([tipo, count]) => (
                                <div key={tipo} style={{ background: theme.bg, padding: '6px 12px', borderRadius: '8px', border: `0.5px solid ${theme.border}` }}>
                                  <div style={{ fontSize: '11px', color: theme.secondary }}>{tipo}</div>
                                  <div style={{ fontSize: '16px', fontWeight: '700', color: theme.primary }}>{count}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        {clinicaSelData.turnos?.porMedico && (
                          <div style={{ marginTop: '12px' }}>
                            <div style={{ fontSize: '11px', color: theme.secondary, marginBottom: '8px', fontWeight: '500' }}>POR MÉDICO</div>
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                              {Object.entries(clinicaSelData.turnos.porMedico).map(([medico, count]) => (
                                <div key={medico} style={{ background: theme.bg, padding: '6px 12px', borderRadius: '8px', border: `0.5px solid ${theme.border}` }}>
                                  <div style={{ fontSize: '11px', color: theme.secondary }}>{medico}</div>
                                  <div style={{ fontSize: '16px', fontWeight: '700', color: theme.primary }}>{count}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                        <div style={seccion}>Pacientes</div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '10px' }}>
                          {card('Total', clinicaSelData.pacientes?.total, theme.accent, theme.infoBg)}
                          {card('Edad promedio', clinicaSelData.pacientes?.edadPromedio ? clinicaSelData.pacientes.edadPromedio + ' años' : '—', theme.secondary, theme.bgCard)}
                          {card('Masculino', clinicaSelData.pacientes?.porSexo?.masculino, theme.accent, theme.infoBg)}
                          {card('Femenino', clinicaSelData.pacientes?.porSexo?.femenino, theme.success, theme.successBg)}
                          {card('Sin especificar', clinicaSelData.pacientes?.porSexo?.otro, theme.secondary, theme.bgCard)}
                        </div>
                      </div>

                      <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                        <div style={seccion}>Caja</div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '10px', marginBottom: '16px' }}>
                          {card('Ingresos ARS', '$' + (clinicaSelData.caja?.totalIngresosARS || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.success, theme.successBg)}
                          {card('Egresos ARS', '$' + (clinicaSelData.caja?.totalEgresosARS || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.error, theme.errorBg)}
                          {card('Resultado ARS', '$' + (clinicaSelData.caja?.resultadoARS || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), (clinicaSelData.caja?.resultadoARS || 0) >= 0 ? theme.success : theme.error, (clinicaSelData.caja?.resultadoARS || 0) >= 0 ? theme.successBg : theme.errorBg)}
                          {card('Ingresos USD', 'USD ' + (clinicaSelData.caja?.totalIngresosUSD || 0).toFixed(0), theme.accent, theme.infoBg)}
                          {card('Egresos USD', 'USD ' + (clinicaSelData.caja?.totalEgresosUSD || 0).toFixed(0), theme.warning, theme.warningBg)}
                          {card('Total movimientos', clinicaSelData.caja?.totalMovimientos, theme.secondary, theme.bgCard)}
                        </div>
                        {clinicaSelData.caja?.porMedioPago && (
                          <div>
                            <div style={{ fontSize: '11px', color: theme.secondary, marginBottom: '8px', fontWeight: '500' }}>MEDIOS DE PAGO MÁS USADOS</div>
                            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                              {Object.entries(clinicaSelData.caja.porMedioPago).sort((a, b) => b[1] - a[1]).map(([medio, count]) => (
                                <div key={medio} style={{ background: theme.bg, padding: '6px 12px', borderRadius: '8px', border: `0.5px solid ${theme.border}` }}>
                                  <div style={{ fontSize: '11px', color: theme.secondary }}>{medio}</div>
                                  <div style={{ fontSize: '16px', fontWeight: '700', color: theme.primary }}>{count}</div>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                          <div style={seccion}>Prestadores</div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                            {card('Total', clinicaSelData.prestadores?.total)}
                            {card('Activos', clinicaSelData.prestadores?.activos, theme.success, theme.successBg)}
                          </div>
                        </div>
                        <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                          <div style={seccion}>Usuarios</div>
                          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                            {card('Total', clinicaSelData.usuarios?.total)}
                            {card('Activos', clinicaSelData.usuarios?.activos, theme.success, theme.successBg)}
                          </div>
                        </div>
                      </div>

                      <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                        <div style={seccion}>Derivadores</div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '10px' }}>
                          {card('Total derivadores', clinicaSelData.derivadores?.total)}
                          {card('Liquidaciones', clinicaSelData.derivadores?.liquidaciones)}
                          {card('Liquidaciones pagas', clinicaSelData.derivadores?.liquidacionesPagadas, theme.success, theme.successBg)}
                          {card('Total liquidado', '$' + (clinicaSelData.derivadores?.totalLiquidado || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.accent, theme.infoBg)}
                          {card('Total pagado', '$' + (clinicaSelData.derivadores?.totalPagado || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.success, theme.successBg)}
                        </div>
                      </div>

                      <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                        <div style={seccion}>Financiaciones</div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                          <div>
                            <div style={{ fontSize: '12px', color: theme.accent, fontWeight: '600', marginBottom: '10px' }}>A CLIENTES</div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                              {card('Total', clinicaSelData.financiaciones?.clientes?.total)}
                              {card('Activas', clinicaSelData.financiaciones?.clientes?.activas, theme.success, theme.successBg)}
                              {card('Financiado', '$' + (clinicaSelData.financiaciones?.clientes?.totalFinanciado || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.accent, theme.infoBg)}
                              {card('Cobrado', '$' + (clinicaSelData.financiaciones?.clientes?.totalCobrado || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.success, theme.successBg)}
                              {card('% cobrado', (clinicaSelData.financiaciones?.clientes?.porcentajeCobrado || 0) + '%', theme.accent, theme.infoBg)}
                            </div>
                          </div>
                          <div>
                            <div style={{ fontSize: '12px', color: theme.warning, fontWeight: '600', marginBottom: '10px' }}>CON PROVEEDORES</div>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                              {card('Total', clinicaSelData.financiaciones?.proveedores?.total)}
                              {card('Activas', clinicaSelData.financiaciones?.proveedores?.activas, theme.warning, theme.warningBg)}
                              {card('Financiado', '$' + (clinicaSelData.financiaciones?.proveedores?.totalFinanciado || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.warning, theme.warningBg)}
                              {card('Pagado', '$' + (clinicaSelData.financiaciones?.proveedores?.totalPagado || 0).toLocaleString('es-AR', { maximumFractionDigits: 0 }), theme.success, theme.successBg)}
                              {card('% pagado', (clinicaSelData.financiaciones?.proveedores?.porcentajePagado || 0) + '%', theme.warning, theme.warningBg)}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div style={{ background: theme.bgCard, borderRadius: '12px', border: `0.5px solid ${theme.border}`, padding: '20px' }}>
                        <div style={seccion}>Inventario</div>
                        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: '10px' }}>
                          {card('Total insumos', clinicaSelData.inventario?.total)}
                          {card('Con alerta stock', clinicaSelData.inventario?.conAlerta, theme.error, theme.errorBg)}
                        </div>
                      </div>

                    </div>
                  )}
                </div>
              </>
        }
      </div>
    </div>
  );
}